import { ArrowLeftIcon } from '@/shared/ui'
import { designTokens } from '@/shared/lib/design-tokens'
import { typographyStyle } from '@/shared/lib/catalog'

const backButtonTextStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.inverse,
  ...typographyStyle(designTokens.typography.body.base, {
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.15px',
  }),
}

type CatalogBackButtonProps = {
  label?: string
  onClick: () => void
}

export function CatalogBackButton({ label = 'Назад', onClick }: CatalogBackButtonProps) {
  return (
    <button
      type="button"
      className="inline-flex w-fit cursor-pointer items-center gap-1.5 rounded-md transition-opacity hover:opacity-80"
      onClick={onClick}
    >
      <ArrowLeftIcon width={24} height={24} className="shrink-0 text-[#FEFEFE]" />
      <span style={backButtonTextStyle}>{label}</span>
    </button>
  )
}

CatalogBackButton.displayName = 'CatalogBackButton'
